<template>
  <div class="wrapper-member">
    <div class="member-content">
      <div class="base-info-top">
        <div class="id-card-pic">
          <el-image
              style="width: 100px; height: 100px; margin-right: 10px"
              :src="member ? member.identityFrontImageUrl : ''"
              :preview-src-list="member ? [member.identityFrontImageUrl] : []"
          />
          <el-image
              style="width: 100px; height: 100px"
              :src="member ? member.identityBackImageUrl : ''"
              :preview-src-list="member ? [member.identityBackImageUrl] : []"
          />
        </div>

        <div class="person-info">
          <el-row :gutter="24">
            <el-col :span="14">
              <div>
                <div class="jc-info">
                  <span class="name fw700">{{ member ? member.memberName : '' }}</span>
                  <div class="tag">
                    <el-tag type="primary" effect="plain">年龄：{{ member ? member.age : '' }}</el-tag>
                    <el-tag type="primary" effect="plain">性别：{{ member ? member.genderName : '' }}</el-tag>
                  </div>
                </div>
                <span v-for="(item, i) in detailInfo.rosterLevelList" :key="i">
                  <span class="tag-ku black" v-if="item == 2" style="margin: 2px">黑名单</span>
                  <span class="tag-ku white" v-if="item == 1" style="margin: 2px">白名单</span>
                </span>
              </div>

              <div>
                <span class="mr50">
                  <span class="label">手机号：</span>
                  <span class="fw700">{{ member ? member.mobile : '' }}</span>
                </span>
                <span>
                <span class="label">身份证号：</span>
                <span class="fw700">{{ member ? member.identityNo : '' }}</span>
              </span>
              </div>

              <div>
                <span>
                  <span class="label">户籍地：</span>
                  <span class="fw700">{{ member ? member.identityAddress : '' }}</span>
                </span>
              </div>
            </el-col>

            <el-col :span="10">
              <div class="person-stat">
                <div class="hit-grade" v-if="!!detailInfo.store">
                  <span class="label">审核评级</span>
                  <TagLv class="tag" :name="scoreProfileData.sysHitGrade || ''" />
                  <TagLv class="tag" :name="scoreProfileData.finalHitGrade || ''" />
                </div>

                <div class="order-stat">
                  <span>申请量：{{ member ? member.applyOrderNum : '' }}</span>
                  <span>成单量：{{ member ? member.dealOrderNum : '' }}</span>
                  <span>结单量：{{ member ? member.fullPayOrderNum : '' }}</span>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="supplement-info">
        <div class="section-title">
          <i class="el-icon-document"></i>
          <span>补充资料</span>
        </div>
        <div class="special-card">
          <el-row>
            <el-col
                v-for="(item, index) in personInfoList"
                :key="index"
                :span="item.span ? item.span : 6"
            >
              <span class="label">{{ item.label }}</span>
              <span class="value">
                {{ orderMemberProfile[item.prop] === 'N' ? '否' : (orderMemberProfile[item.prop] === 'Y' ? '是'
                  : (orderMemberProfile[item.prop] || '')) }}
              </span>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { authBtnMixin } from '@/mixins/authBtnMixin';

export default {
  mixins: [authBtnMixin],

  name: 'BaseInfo',

  props: {
      detailInfo: {
          type: Object,
          default: () => {},
      },
      member: {
          type: Object,
          default: () => {},
      },
  },

  inject: ['reload'],

  data() {
    return {
      orderMemberProfileData: {
        orderNo: "",
        memberId: "",
        workCompany: "",
        income: "",
        overdueStatus: "",
      },
      scoreProfileData: {
        orderNo: "",
        sysHitScore: "",
        sysHitSuggestDesc: "",
        sysHitGrade: "",
        finalHitGrade: "",
      },
      personInfoList: [
        {
          prop: "zmScore",
          label: "芝麻分：",
          required: true,
          inputType: "number",
          span: 5,
        },
        {
          prop: "overdueStatus",
          label: "是否逾期：",
          span: 5,
        },
        {
          prop: "workCompany",
          label: "工作单位：",
          span: 9,
        },
        {
          prop: "income",
          label: "薪资：",
          span: 5,
        },
      ],
    };
  },

  computed: {
    orderMemberProfile() {
      return this.detailInfo.orderMemberProfile || {};
    },
    orderScoreProfile() {
      return this.detailInfo.orderScoreProfile || {};
    },
  },

  watch: {
    orderMemberProfile(val) {
      if (val) {
        this.orderMemberProfileData = { ...this.orderMemberProfile, ...val };
      }
    },

    orderScoreProfile(val) {
      if (val) {
        this.scoreProfileData = { ...this.orderScoreProfile, ...val };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.without-layout .wrapper-member {
  padding: 0 !important;
}

.wrapper-member {
  width: 100%;
}

.member-content {
  width: 100%;
}

.fw700 {
  font-weight: 700;
}

.label {
  color: #606266;
  font-size: 14px;
}

.base-info-top {
  display: flex;
  align-items: flex-start;
  padding: 0;

  .id-card-pic {
    margin-right: 24px;
    
    .el-image {
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }
    }
  }

  .person-info {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    line-height: 32px;

    .mr50 {
      margin-right: 50px;
    }

    .el-tag {
      height: 26px;
      border-radius: 13px;
      margin-right: 8px;
      line-height: 26px;
      padding: 0 12px;
      font-size: 12px;
      border: none;
    }

    .jc-info {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 16px;
      margin-bottom: 12px;

      .name {
        color: #303133;
        font-size: 22px;
        font-weight: 700;
        font-family: 微软雅黑;
      }
      
      .tag {
        display: flex;
        gap: 8px;
      }
    }

    .person-stat {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #303133;
      gap: 12px;
      padding: 16px;
      background: linear-gradient(135deg, #f8f9fa 0%, #f0f2f5 100%);
      border-radius: 10px;
      border: 1px solid #e4e7ed;

      .hit-grade {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        .label {
          font-size: 14px;
          font-weight: 600;
          margin-right: 12px;
          color: #303133;
        }

        .tag {
          margin: 0 4px;
        }
      }

      .order-stat {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        gap: 16px;

        span {
          font-size: 13px;
          color: #606266;
          padding: 4px 12px;
          background: #ffffff;
          border-radius: 6px;
          border: 1px solid #e4e7ed;
        }
      }
    }
  }
}

.tag-ku {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  margin-right: 8px;
  color: #fff;
  font-weight: 500;
  display: inline-block;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.black {
  background: linear-gradient(135deg, #f56c6c 0%, #d05252 100%);
}

.white {
  background: linear-gradient(135deg, #67c23a 0%, #4cd2a2 100%);
}

.supplement-info {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #e4e7ed;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  
  i {
    font-size: 18px;
    color: #409EFF;
  }
}

.special-card {
  background: linear-gradient(135deg, #f8f9fa 0%, #f0f2f5 100%);
  line-height: 36px;
  padding: 16px 20px;
  border-radius: 10px;
  border: 1px solid #e4e7ed;

  .label {
    display: inline-block;
    min-width: 120px;
    text-align: right;
    color: #606266;
    font-weight: 500;
  }

  .value {
    font-weight: 600;
    color: #303133;
  }
}

.el-image {
  border-radius: 8px;
  overflow: hidden;
}
</style>
